<template>
  <header class="admin-header">
    <!-- Left Section - Logo & Navigation -->
    <div class="header-left">
      <img
        class="header-logo"
        alt="IdeasFundX Logo"
        src="../../assets/logo.png"
      />

      <nav class="header-nav">
        <a 
          class="nav-link" 
          :class="{ active: activePage === 'DashboardAdminCompany' }"
          @click="redirectTo('/admin/company')"
        >
          <svg class="nav-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
            <polyline points="9 22 9 12 15 12 15 22"></polyline>
          </svg>
          Companies
        </a>
        <a 
          class="nav-link" 
          :class="{ active: activePage === 'DashboardAdminInvestor' }"
          @click="redirectTo('/admin/investor')"
        >
          <svg class="nav-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
          Investors
        </a>
      </nav>
    </div>

    <!-- Right Section - Actions & Profile -->
    <div class="header-right">
      <!-- Search Button -->
      <button class="header-action" title="Search">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
      </button>

      <!-- Divider -->
      <div class="header-divider"></div>

      <!-- User Profile -->
      <div class="user-profile" @click="RightSidebarPanel()">
        <div class="user-avatar">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
        </div>
        <span class="user-name">Admin</span>
        <svg class="dropdown-arrow" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
      </div>

      <!-- Settings Button -->
      <button class="header-action settings-btn" @click="RightSidebarPanel()" title="Settings">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="3"></circle>
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
        </svg>
      </button>
    </div>

    <!-- Sidebar Panel -->
    <div class="sidebar-overlay" v-if="isPanelRightOpen" @click="RightSidebarPanel()"></div>
    
    <transition name="slide-panel">
      <div v-if="isPanelRightOpen" class="sidebar-panel">
        <div class="panel-header">
          <h3>Settings</h3>
          <button class="panel-close" @click="RightSidebarPanel()">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
        <div class="panel-content">
          <button class="panel-item logout" @click="submitLogout()">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
              <polyline points="16 17 21 12 16 7"></polyline>
              <line x1="21" y1="12" x2="9" y2="12"></line>
            </svg>
            <span>Logout</span>
          </button>
        </div>
      </div>
    </transition>
  </header>
</template>

<script>
export default {
  props: { avatarPreviewUrl: String },

  data() {
    return {
      CMSlink: `window.location=\'${process.env.VUE_APP_CMS_URL}\';`,
      isPanelRightOpen: false,
      activePage: '',
      profile: localStorage.profile,
    };
  },

  methods: {
    RightSidebarPanel() {
      this.isPanelRightOpen = !this.isPanelRightOpen;
    },

    changeComponent() {
      this.isPanelRightOpen = false;
      this.$emit("changeComponent", null, "changepwd");
    },

    submitLogout() {
      localStorage.profile = '';
      this.$router.push('/admin');  
    },

    redirectTo(route) {
      this.$router.push(route);
    },
  },

  created() {
    this.activePage = this.$route.name;
    if (!this.profile) {
      this.$router.push('/admin');
    }
  }
};
</script>

<style scoped>
.admin-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 70px;
  padding: 0 24px;
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
}

/* Left Section */
.header-left {
  display: flex;
  align-items: center;
  gap: 40px;
}

.header-logo {
  height: 32px;
  width: auto;
}

/* Navigation */
.header-nav {
  display: flex;
  align-items: center;
  gap: 8px;
}

.nav-link {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  color: #64748b;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.nav-link:hover {
  background: linear-gradient(135deg, #00aac3 0%, #0891b2 100%);
  color: #ffffff !important;
}

.nav-link.active {
  background: linear-gradient(135deg, #00aac3 0%, #0891b2 100%);
  color: #ffffff !important;
}

.nav-link.active .nav-icon {
  color: #ffffff;
}

.nav-icon {
  width: 18px;
  height: 18px;
}

/* Right Section */
.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-action {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: #f1f5f9;
  border: none;
  border-radius: 10px;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s ease;
}

.header-action:hover {
  background: rgba(0, 170, 195, 0.1);
  color: #00aac3;
  transform: scale(1.05);
}

.header-divider {
  width: 1px;
  height: 32px;
  background: #e5e7eb;
  margin: 0 8px;
}

/* User Profile */
.user-profile {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 12px 6px 6px;
  background: #f1f5f9;
  border-radius: 30px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.user-profile:hover {
  background: rgba(0, 170, 195, 0.1);
}

.user-avatar {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #00aac3 0%, #0891b2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.user-name {
  color: #1e293b;
  font-size: 14px;
  font-weight: 600;
}

.dropdown-arrow {
  color: #64748b;
  transition: transform 0.2s ease;
}

.user-profile:hover .dropdown-arrow {
  transform: translateY(2px);
}

/* Sidebar Panel */
.sidebar-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 200;
  backdrop-filter: blur(2px);
}

.sidebar-panel {
  position: fixed;
  top: 0;
  right: 0;
  width: 300px;
  height: 100vh;
  background: #ffffff;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);
  z-index: 201;
  display: flex;
  flex-direction: column;
}

.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
}

.panel-header h3 {
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}

.panel-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: #f1f5f9;
  border: none;
  border-radius: 8px;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s ease;
}

.panel-close:hover {
  background: #e2e8f0;
  color: #1e293b;
}

.panel-content {
  padding: 16px;
  flex: 1;
}

.panel-item {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 14px 16px;
  background: none;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  color: #4b5563;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
}

.panel-item:hover {
  background: #f1f5f9;
}

.panel-item.logout {
  color: #ef4444;
}

.panel-item.logout:hover {
  background: rgba(239, 68, 68, 0.1);
}

/* Transitions */
.slide-panel-enter-active,
.slide-panel-leave-active {
  transition: transform 0.3s ease;
}

.slide-panel-enter-from,
.slide-panel-leave-to {
  transform: translateX(100%);
}

/* Responsive */
@media (max-width: 768px) {
  .admin-header {
    padding: 0 16px;
  }

  .header-left {
    gap: 20px;
  }

  .header-logo {
    height: 26px;
  }

  .nav-link span {
    display: none;
  }

  .nav-link {
    padding: 10px;
  }

  .user-name {
    display: none;
  }

  .sidebar-panel {
    width: 100%;
  }
}
</style>
